import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 引入bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

import "normalize.css"
import "swiper/css";
import 'vant/lib/index.css';

import '@/assets/css/common.scss'

createApp(App).use(router).mount('#app')
